module.exports = __webpack_public_path__ + "img/0_f.a75f7fd3.jpg";